import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from '../../../../components/atoms/SVG';
import { ExtendedInfoStateIndicator, ExtendedInfoSVG } from '../../../../_lib/components/ExtendedInfo';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { Namespace } from '../../../../translation/namespace';

type TopItemSymbol = {
  type: 'readRestriction' | 'draft' | 'template';
};

export function TopItemSymbol({ type }: TopItemSymbol) {
  const { t } = useTranslation(Namespace.MainNavigation);
  return (
    <span className="main-navigation__symbol">
      {type === 'readRestriction' && (
        <ExtendedInfoSVG
          helpText={t('topItem.restricted')}
          tooltipPlacement={TooltipPlacement.TOP}
          svgSpriteID={Icons.CLOSED_LOCK}
        />
      )}
      {type === 'draft' && (
        <ExtendedInfoStateIndicator tooltipPlacement={TooltipPlacement.TOP} stateIndicatorStatus="red" />
      )}
      {type === 'template' && (
        <ExtendedInfoStateIndicator tooltipPlacement={TooltipPlacement.TOP} stateIndicatorStatus="purple" />
      )}
    </span>
  );
}
